import { render, staticRenderFns } from "./TwItem.vue?vue&type=template&id=7ccca54f&"
import script from "./TwItem.vue?vue&type=script&lang=ts&"
export * from "./TwItem.vue?vue&type=script&lang=ts&"
import style0 from "./TwItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports